import API from '../../api';
import ENDPOINTS from '../../endpoints';
import {
  useMutation,
  MutationResultPair
} from 'react-query';
import GlobalContext from '../../contexts/GlobalContext';
import { payload as payloadData } from '../../types/regulatoryUpdateBundle';
import { useContext } from 'react';
export const usePostJson = (options?: {
  onSuccess?: Function;
  onError?: Function;
  enabled?: boolean;
}): MutationResultPair<void, unknown, payloadData, unknown> => {
  const endPoints = ENDPOINTS();
  const globalContextValue = useContext(GlobalContext);
  const { globalContext } = globalContextValue;
  const postSubmit = async (payload: payloadData): Promise<void> => {
    // eslint-disable-next-line camelcase, @typescript-eslint/camelcase
    payload.device_type = globalContext.gb.utils.getClusterValue();
    payload.site = globalContext.liquid.siteName;
    let appDataUrl = endPoints.regulatoryUpdateBundlePostSubmit();
    let response;
    try {
      response = await API.post(appDataUrl, payload);    
    } catch (error) {
      throw new Error(error);
    }
    // eslint-disable-next-line camelcase, @typescript-eslint/camelcase
    if (response.data.status.code !== 0) {
      throw new Error(response.data.status.code);
    }
  };
  return useMutation((payload: payloadData) => postSubmit(payload), {
    onSuccess: () => options?.onSuccess(),
    onError: () => options?.onError()
  });
};